import { ContractType, TicketAttachmentDocumentType } from './ticket.model';

export type residentAppSettings = {
  accessRestrictionPeriodMonths: number;
  grantAccessAfterContractExpiration: boolean;
  askForMovingAddressOnEndingContract: boolean;
  digitalDocumentsReceivalMandatory: boolean;
  showStartPageBanner: boolean;
  startPageBannerHeadline: string;
  startPageBannerText: string;
  showFaqCard: boolean;
  faqCardHeadline: string;
  faqCardText: string;
};

export enum CatalogueType {
  GENERAL,
  FLAT,
  GARAGE,
  COMMERCIAL,
  NO_CONTRACT
}

enum TicketIssueType {
  DAMAGE,
  CONCERN
}

export enum MasterDataRequestType {
  TICKET = 'TICKET',
  EXTERNAL = 'EXTERNAL'
}

export enum MasterdataChangeType {
  NAME = 'NAME',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  ADDRESS = 'ADDRESS',
  PHONE = 'PHONE',
  MOBILE = 'MOBILE',
  EMAIL = 'EMAIL',
  PAYMENT = 'PAYMENT'
}

export type LandlordTicketCatalogue = {
  id: string;
  catalogueType: CatalogueType;
  issueType: TicketIssueType;
  contractType: ContractType;
  lastUpdate: Date;
  downloadPossible: boolean;
};

export type TicketCategoryType = {
  id: string;
  publicId: string;
  name: string;
};

export type MasterDataChangeConfigurationType = {
  gracePeriod: number;
  masterdataChangeConfigurationItems: MasterDataConfigurationItemType[];
};

export type MasterDataConfigurationItemType = {
  changeType: MasterdataChangeType;
  requestType: MasterDataRequestType;
  ticketCategory?: TicketCategoryType;
  externalPaymentData?: {
    notice: string;
    restrictionPeriodStartDay: number;
    restrictionPeriodEndDay: number;
    singleContractRequest: boolean;
  };
};

export type MasterDataChangeConfigurationInput = {
  gracePeriod: number;
  masterdataChangeConfigurationItems: MasterDataConfigurationItemInput[];
};

export type MasterDataConfigurationItemInput = {
  changeType: MasterdataChangeType;
  requestType: MasterDataRequestType;
  ticketCategoryId?: string;
  externalPaymentData?: {
    notice: string;
    restrictionPeriodStartDay: number;
    restrictionPeriodEndDay: number;
    singleContractRequest: boolean;
  };
};

export type ResidentLandlordNotificationSettings = {
  email?: string;
  forwardContentEmails?: boolean;
  forwardDocumentEmails?: boolean;
  forwardTicketEmails?: boolean;
  forwardPaymentEmails?: boolean;
  forwardLegalTextEmails?: boolean;
};

export type CategoryQuestionAnswerSorting = 'LAST_CHANGED' | 'ALPHANUMERIC';

/**
 * Whether tickets are handled inside Immomio or handed off to an external
 * system. Landlord-side ticket creation is only offered for INTERNAL.
 */
export type TicketingType = 'INTERNAL' | 'EXTERNAL';

export type TicketSettings = {
  ticketingType?: TicketingType;
  allowedConcernTicketAttachmentFileTypes?: TicketAttachmentDocumentType[];
  allowedDamageTicketAttachmentFileTypes?: TicketAttachmentDocumentType[];
  enableTicketMessengerForDamages?: boolean;
  enableTicketMessengerForConcerns?: boolean;
  allowContractlessTicketCreationForDamages?: boolean;
  allowContractlessTicketCreationForOtherConcerns?: boolean;
  includeContractInMasterdataChangeTickets?: boolean;
  damageMessagesReadOnly?: boolean;
  concernMessagesReadOnly?: boolean;
  categoryQuestionAnswerSorting?: CategoryQuestionAnswerSorting;
};
